import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss'; 
 
 
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));
//ElectricityPaymentDetailReportDw
const ProductDetail = React.lazy(() => import('./views/pages/login/ProductDetail')); 
const AddProduct = React.lazy(() => import('./views/pages/login/AddProduct')); 
const ItemsD = React.lazy(() => import('./views/pages/login/ItemsD')); 
const Cart = React.lazy(() => import('./views/pages/Cart/Cart'));  
const Login = React.lazy(() => import('./views/pages/login/Login2')); 

const Register = React.lazy(() => import('./views/pages/register/Register'));

const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));

const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
 

//CustomerReport
//LedgerElectric
//TaxesDetailReport
//TaxesReport
//PaymentSummary
//Elect_Bill
//payment_detail_rpt
class App extends Component {


 componentDidMount(){
  //requestPermission();
 
 }
  render() {
    return (
<>


      <BrowserRouter>
          <React.Suspense fallback={loading}>
          <Switch>

          <Route exact path="/AddProduct" name="AddProduct Page" render={props => <AddProduct {...props}/>} /> 
              <Route exact path="/Home" name="Home Page" render={props => <ItemsD {...props}/>} /> 
              <Route exact path="/Product/:id" name="Home Page" render={props => <ProductDetail {...props}/>} /> 
              <Route exact path="/Cart" name="Cart Page" render={props => <Cart {...props}/>} /> 
              
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} /> 
 
              <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />

            <Route path="/" name="Home" render={props => <TheLayout {...props} />} />


           
            </Switch>
          </React.Suspense>
      </BrowserRouter>
      
      </>
    );
  }
}

export default App;
